export const VideoHelpIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M10 7.87363C10.0003 7.71817 10.0418 7.56559 10.1203 7.43158C10.1987 7.29758 10.3113 7.18698 10.4465 7.11116C10.5816 7.03534 10.7344 6.99703 10.8892 7.00018C11.0439 7.00333 11.1951 7.04782 11.327 7.12907L15.5848 9.75369C15.7116 9.832 15.8164 9.94166 15.8891 10.0722C15.9618 10.2028 16 10.3498 16 10.4994C16 10.649 15.9618 10.7961 15.8891 10.9266C15.8164 11.0572 15.7116 11.1668 15.5848 11.2451L11.327 13.8709C11.1949 13.9523 11.0436 13.9968 10.8886 13.9998C10.7336 14.0029 10.5807 13.9644 10.4455 13.8883C10.3102 13.8122 10.1977 13.7012 10.1194 13.5669C10.0411 13.4326 9.99988 13.2797 10 13.124V7.87363Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M12 19V22"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M8 22H16"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M20.8 3H3.2C1.98497 3 1 3.95939 1 5.14286V15.8571C1 17.0406 1.98497 18 3.2 18H20.8C22.015 18 23 17.0406 23 15.8571V5.14286C23 3.95939 22.015 3 20.8 3Z"
            stroke="black"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
);
